<template>
  <div>
    <div class="appui">
      <div class="appui-head">
        <div>
          <h1 class="appui-title">Loja de Pontos</h1>
          <div class="appui-crumb">App <span class="sep">/</span> Loja de Pontos</div>
        </div>
      </div>

      <div class="appui-tabs">
        <button :class="{ 'is-active': activeTab === 'produtos' }" @click="activeTab = 'produtos'"><i class="bx bx-gift" style="margin-right:5px"></i>Produtos</button>
        <button :class="{ 'is-active': activeTab === 'pedidos' }" @click="switchTab('pedidos')"><i class="bx bx-package" style="margin-right:5px"></i>Pedidos</button>
        <button :class="{ 'is-active': activeTab === 'carteira' }" @click="switchTab('carteira')"><i class="bx bx-wallet" style="margin-right:5px"></i>Carteira</button>
      </div>

      <!-- PRODUTOS -->
      <section v-if="activeTab === 'produtos'" class="appui-card appui-card--flush">
        <div class="appui-card-toolbar">
          <div class="appui-card-toolbar-left">
            <span class="appui-toolbar-hint"><i class="mdi mdi-drag-vertical"></i> Arraste para reordenar a vitrine do app.</span>
          </div>
          <div class="appui-card-toolbar-right">
            <button class="appui-btn appui-btn--ghost" @click="categoryModal = true"><i class="mdi mdi-tag-multiple-outline mr-1"></i> Categorias</button>
            <button class="appui-btn appui-btn--primary" @click="openProduct()">+ Novo produto</button>
          </div>
        </div>

        <div v-if="!products.length" class="appui-inline-empty">Nenhum produto na vitrine ainda.</div>
        <draggable
          v-else
          :list="products"
          :element="'div'"
          class="appui-grid-4"
          style="padding:16px"
          :options="{ animation: 180, handle: '.appui-grip', ghostClass: 'appui-drag-ghost' }"
          @end="reorderProducts()"
        >
          <div v-for="p in products" :key="p.id" class="appui-product-card">
            <div class="appui-product-photo">
              <img v-if="p.photo" :src="p.photo">
              <i v-else class="bx bx-gift"></i>
              <span class="appui-grip appui-product-grip" title="Arraste para reordenar">⠿</span>
              <span class="appui-badge appui-product-status" :class="p.status ? 'appui-badge--green' : 'appui-badge--muted'" role="button" @click="toggleProduct(p)">{{ p.status ? 'Ativo' : 'Oculto' }}</span>
            </div>
            <div style="padding:12px 14px">
              <div v-if="p.category" style="font-size:10.5px;font-weight:600;text-transform:uppercase;letter-spacing:.04em;color:#adb5bd">{{ p.category.name }}</div>
              <div style="font-weight:600;font-size:13px;color:#495057;margin:2px 0 6px">{{ p.name }}</div>
              <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px">
                <span style="font-weight:700;color:#556ee6;font-size:14px">{{ p.points_cost }} pts</span>
                <span style="font-size:11px" :style="{ color: p.stock_quantity > 0 ? '#74788d' : '#f46a6a' }">{{ p.stock_quantity > 0 ? 'Estoque: ' + p.stock_quantity : 'Esgotado' }}</span>
              </div>
              <div style="display:flex;gap:8px">
                <button class="appui-tbtn" @click="openProduct(p)">Editar</button>
                <button class="appui-tbtn appui-tbtn--danger" @click="delProduct(p)">Excluir</button>
              </div>
            </div>
          </div>
        </draggable>
      </section>

      <!-- PEDIDOS -->
      <section v-if="activeTab === 'pedidos'" class="appui-card appui-card--flush">
        <div class="appui-card-toolbar">
          <div class="appui-card-toolbar-left"><span class="appui-sec-title">Pedidos</span></div>
          <div class="appui-card-toolbar-right">
            <select class="appui-select" v-model="orderFilter" @change="loadOrders()">
              <option value="">Todos os status</option>
              <option value="0">Em processamento</option>
              <option value="1">Enviados</option>
              <option value="2">Entregues</option>
            </select>
            <button class="appui-btn appui-btn--ghost appui-btn--sm" @click="loadOrders()"><i class="mdi mdi-refresh mr-1"></i> Atualizar</button>
          </div>
        </div>

        <div v-if="!orders.length" class="appui-inline-empty">Nenhum pedido ainda.</div>
        <table v-else class="appui-table">
          <thead><tr><th style="width:110px">Pedido</th><th>Participante</th><th>Data</th><th style="width:110px">Total</th><th style="width:150px">Status</th><th style="width:80px;text-align:right"></th></tr></thead>
          <tbody>
            <tr v-for="o in orders" :key="o.id" class="appui-link" @click="openOrder(o)">
              <td style="font-weight:600;color:#495057">#{{ o.id }}</td>
              <td>{{ o.participant ? o.participant.name : '#' + o.participant_id }}</td>
              <td style="color:#74788d">{{ fmtDate(o.created_at) }}</td>
              <td style="font-weight:700;color:#556ee6">{{ o.total }} pts</td>
              <td><span class="appui-badge" :class="orderBadge(o.status)">{{ orderLabels[o.status] }}</span></td>
              <td style="text-align:right"><i class="mdi mdi-chevron-right" style="color:#adb5bd;font-size:17px"></i></td>
            </tr>
          </tbody>
        </table>
      </section>

      <!-- CARTEIRA -->
      <section v-if="activeTab === 'carteira'" class="appui-card appui-card--flush">
        <div class="appui-card-toolbar">
          <div class="appui-card-toolbar-left"><span class="appui-sec-title">Carteira de pontos</span></div>
          <div class="appui-card-toolbar-right">
            <button class="appui-btn appui-btn--primary" @click="openAdjust()"><i class="mdi mdi-cash-plus mr-1"></i> Ajuste manual</button>
          </div>
        </div>
        <div v-if="!balances.length" class="appui-inline-empty">Nenhum participante com saldo ainda.</div>
        <table v-else class="appui-table">
          <thead><tr><th>Participante</th><th style="width:130px;text-align:right">Saldo</th><th style="width:110px;text-align:right"></th></tr></thead>
          <tbody>
            <tr v-for="b in balances" :key="b.participant_id">
              <td style="font-weight:500;color:#495057">{{ b.name || '#' + b.participant_id }}</td>
              <td style="text-align:right;font-weight:700;color:#556ee6">{{ b.balance }} pts</td>
              <td style="text-align:right">
                <button class="appui-tbtn appui-tbtn--primary" @click="openAdjust(b)">Ajustar</button>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
    </div>

    <!-- Modal produto -->
    <b-modal v-model="productModal" :title="productForm.id ? 'Editar produto' : 'Novo produto'" size="lg" hide-footer>
      <form @submit.prevent="saveProduct()">
        <div class="row">
          <div class="col-sm-4">
            <label class="appui-label">Foto</label>
            <input type="file" accept="image/*" ref="photo" style="display:none" @change="onProductPhoto">
            <div class="appui-drop" :class="{ 'has-img': productPreview }" style="min-height:150px" @click="$refs.photo.click()">
              <template v-if="productPreview">
                <img :src="productPreview" class="appui-drop-img">
                <div class="appui-drop-overlay"><span class="appui-drop-btn"><i class="mdi mdi-swap-horizontal"></i> Trocar</span></div>
              </template>
              <template v-else>
                <i class="mdi mdi-cloud-upload-outline appui-drop-icon"></i>
                <span class="appui-drop-title">Clique para enviar</span>
                <span class="appui-drop-hint">Quadrada · até 2 MB</span>
              </template>
            </div>
          </div>
          <div class="col-sm-8">
            <div class="form-group"><label>Nome *</label><input type="text" class="form-control" v-model="productForm.name" required></div>
            <div class="form-group">
              <label>Categoria</label>
              <select class="custom-select" v-model="productForm.category_id"><option :value="null">—</option><option v-for="c in categories" :key="c.id" :value="c.id">{{ c.name }}</option></select>
            </div>
            <div class="row">
              <div class="form-group col-sm-6"><label>Custo (pontos) *</label><input type="number" class="form-control" v-model.number="productForm.points_cost" min="0" required></div>
              <div class="form-group col-sm-6"><label>Estoque *</label><input type="number" class="form-control" v-model.number="productForm.stock_quantity" min="0" required></div>
            </div>
          </div>
        </div>
        <div class="form-group"><label>Descrição</label><textarea class="form-control" rows="3" v-model="productForm.description"></textarea></div>
        <div class="text-right"><button type="button" class="btn btn-light mr-2" @click="productModal = false">Cancelar</button><button type="submit" class="btn btn-primary" :disabled="saving">Salvar</button></div>
      </form>
    </b-modal>

    <!-- Modal categorias -->
    <b-modal v-model="categoryModal" title="Categorias da loja" hide-footer>
      <form class="d-flex mb-3" style="gap:8px" @submit.prevent="saveCategory()">
        <input type="text" class="form-control" v-model.trim="categoryForm.name" :placeholder="categoryForm.id ? 'Renomear categoria' : 'Nova categoria'" required>
        <button type="submit" class="btn btn-primary" style="flex:none">{{ categoryForm.id ? 'Salvar' : 'Adicionar' }}</button>
        <button v-if="categoryForm.id" type="button" class="btn btn-light" style="flex:none" @click="categoryForm = { id: null, name: '' }">Cancelar</button>
      </form>
      <table class="appui-table">
        <tbody>
          <tr v-for="c in categories" :key="c.id">
            <td class="appui-link" title="Clique para renomear" @click="categoryForm = { id: c.id, name: c.name }">{{ c.name }}</td>
            <td style="width:50px;text-align:right">
              <button class="appui-icon-btn appui-icon-btn--danger" @click="delCategory(c)"><i class="mdi mdi-trash-can-outline"></i></button>
            </td>
          </tr>
          <tr v-if="!categories.length"><td colspan="2" class="appui-empty">Nenhuma categoria.</td></tr>
        </tbody>
      </table>
      <div class="text-right" style="margin-top:12px"><button class="btn btn-light" @click="categoryModal = false">Fechar</button></div>
    </b-modal>

    <!-- Modal pedido (detalhe + atualizar) -->
    <b-modal v-model="orderModal" :title="'Pedido #' + (orderForm.id || '')" size="lg" hide-footer>
      <div class="row" style="font-size:13px;margin-bottom:8px">
        <div class="col-sm-4"><span class="appui-label">Participante</span>{{ orderForm.participant ? orderForm.participant.name : '—' }}</div>
        <div class="col-sm-4"><span class="appui-label">Data</span>{{ fmtDate(orderForm.created_at) }}</div>
        <div class="col-sm-4"><span class="appui-label">Total</span><strong style="color:#556ee6">{{ orderForm.total }} pts</strong></div>
      </div>
      <table class="appui-table" style="margin-bottom:16px">
        <thead><tr><th style="width:56px"></th><th>Item</th><th style="width:60px">Qtd</th><th style="width:90px;text-align:right">Pontos</th></tr></thead>
        <tbody>
          <tr v-for="it in (orderForm.items || [])" :key="it.id">
            <td><span class="appui-avatar" style="width:38px;height:38px"><img v-if="it.product && it.product.photo" :src="it.product.photo"><template v-else><i class="bx bx-gift"></i></template></span></td>
            <td style="font-weight:500;color:#495057">{{ it.product ? it.product.name : '—' }}</td>
            <td style="color:#74788d">{{ it.quantity }}</td>
            <td style="text-align:right;color:#74788d">{{ it.points_cost }}</td>
          </tr>
        </tbody>
      </table>
      <form @submit.prevent="saveOrder()">
        <div class="row">
          <div class="form-group col-sm-4">
            <label>Status *</label>
            <select class="custom-select" v-model.number="orderForm.status">
              <option :value="0">Em processamento</option>
              <option :value="1">Enviado</option>
              <option :value="2">Entregue</option>
            </select>
          </div>
          <div class="form-group col-sm-4">
            <label>Tipo de entrega</label>
            <select class="custom-select" v-model="orderForm.delivery_type">
              <option :value="null">—</option>
              <option value="Transportadora">Transportadora</option>
              <option value="Correios">Correios</option>
              <option value="Retirou no local">Retirou no local</option>
            </select>
          </div>
          <div class="form-group col-sm-4" v-if="orderForm.delivery_type && orderForm.delivery_type !== 'Retirou no local'">
            <label>Código de rastreio</label>
            <input type="text" class="form-control" v-model="orderForm.tracking_code">
          </div>
        </div>
        <div class="text-right">
          <button type="button" class="btn btn-light mr-2" @click="orderModal = false">Fechar</button>
          <button type="submit" class="btn btn-primary" :disabled="saving">Atualizar pedido</button>
        </div>
      </form>
    </b-modal>

    <!-- Modal ajuste de carteira -->
    <b-modal v-model="adjustModal" title="Ajuste manual de pontos" hide-footer>
      <form @submit.prevent="doAdjust()">
        <div class="form-group">
          <label>Participante (ID) *</label>
          <input type="number" class="form-control" v-model.number="adjustForm.participant_id" :disabled="!!adjustForm.locked" required>
          <small v-if="adjustForm.name" class="text-muted">{{ adjustForm.name }}</small>
        </div>
        <div class="row">
          <div class="form-group col-sm-6">
            <label>Operação *</label>
            <select class="custom-select" v-model="adjustForm.type"><option value="credit">Crédito (+)</option><option value="debit">Débito (−)</option></select>
          </div>
          <div class="form-group col-sm-6"><label>Pontos *</label><input type="number" class="form-control" v-model.number="adjustForm.points" min="1" required></div>
        </div>
        <div class="form-group"><label>Justificativa</label><input type="text" class="form-control" v-model="adjustForm.description" placeholder="ex: bônus de credenciamento"></div>
        <div class="text-right"><button type="button" class="btn btn-light mr-2" @click="adjustModal = false">Cancelar</button><button type="submit" class="btn btn-primary" :disabled="saving">Aplicar</button></div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import services from './services'
import './app-ui.css'

export default {
  components: { draggable },
  name: 'app-store',
  data () {
    return {
      activeTab: 'produtos',
      products: [],
      categories: [],
      orders: [],
      orderFilter: '',
      balances: [],
      saving: false,
      productModal: false,
      productForm: {},
      productPreview: null,
      photoFile: null,
      categoryModal: false,
      categoryForm: { id: null, name: '' },
      orderModal: false,
      orderForm: {},
      adjustModal: false,
      adjustForm: { participant_id: null, type: 'credit', points: 0, description: '' },
      orderLabels: ['Em processamento', 'Enviado', 'Entregue']
    }
  },
  mounted () { this.loadProducts(); this.loadCategories() },
  methods: {
    switchTab (tab) {
      this.activeTab = tab
      if (tab === 'pedidos') this.loadOrders()
      if (tab === 'carteira') this.loadBalances()
    },
    fmtDate (d) {
      if (!d) return '—'
      const dt = new Date(String(d).replace(' ', 'T'))
      if (isNaN(dt)) return d
      return dt.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
    },
    orderBadge (s) { return s === 2 ? 'appui-badge--green' : (s === 1 ? 'appui-badge--blue' : '') },
    loadProducts () { services.adminListStoreProducts().then(r => { this.products = r.data.data }) },
    loadCategories () { services.adminListStoreCategories().then(r => { this.categories = r.data.data }) },
    loadOrders () { services.adminListStoreOrders({ status: this.orderFilter || undefined, limit: 100 }).then(r => { this.orders = r.data.data }) },
    loadBalances () { services.listWalletBalances({ limit: 100 }).then(r => { this.balances = r.data.data }) },
    // Produtos
    openProduct (p) {
      this.productForm = p
        ? { id: p.id, name: p.name, description: p.description, points_cost: p.points_cost, stock_quantity: p.stock_quantity, category_id: p.category_id }
        : { id: null, name: '', description: '', points_cost: 0, stock_quantity: 0, category_id: null }
      this.photoFile = null
      this.productPreview = p ? p.photo : null
      this.productModal = true
    },
    onProductPhoto (e) {
      const f = e.target.files[0]
      e.target.value = ''
      if (!f) return
      if (!f.type.startsWith('image/')) { errorMessage('Envie um arquivo de imagem.', 2500); return }
      if (f.size > 2 * 1024 * 1024) { errorMessage('A imagem deve ter no máximo 2 MB.', 2500); return }
      this.photoFile = f
      this.productPreview = URL.createObjectURL(f)
    },
    async saveProduct () {
      this.saving = true
      try {
        const fd = new FormData()
        ;['name', 'description', 'points_cost', 'stock_quantity', 'category_id'].forEach(k => {
          if (this.productForm[k] != null && this.productForm[k] !== '') fd.append(k, this.productForm[k])
        })
        if (this.photoFile) fd.append('photo', this.photoFile)
        if (this.productForm.id) {
          fd.append('_method', 'PUT')
          await services.updateStoreProduct(this.productForm.id, fd)
        } else {
          await services.createStoreProduct(fd)
        }
        this.productModal = false
        successMessage('Produto salvo.', 2000)
        this.loadProducts()
      } catch (e) { errorMessage('Falha ao salvar produto.', 3000) } finally { this.saving = false }
    },
    async toggleProduct (p) { try { await services.storeProductStatus(p.id); p.status = p.status ? 0 : 1 } catch (e) { errorMessage('Falha.', 3000) } },
    async delProduct (p) {
      const ok = await this.$bvModal.msgBoxConfirm(`Remover "${p.name}"?`, { okTitle: 'Remover', cancelTitle: 'Cancelar', okVariant: 'danger' })
      if (!ok) return
      try { await services.deleteStoreProduct(p.id); this.loadProducts() } catch (e) { errorMessage('Falha ao remover.', 3000) }
    },
    async reorderProducts () {
      try { await services.reorderStoreProducts(this.products.map(it => ({ id: it.id }))) } catch (e) { errorMessage('Falha ao reordenar.', 3000); this.loadProducts() }
    },
    // Categorias
    async saveCategory () {
      if (!this.categoryForm.name) return
      try {
        if (this.categoryForm.id) await services.updateStoreCategory(this.categoryForm.id, { name: this.categoryForm.name })
        else await services.createStoreCategory({ name: this.categoryForm.name })
        this.categoryForm = { id: null, name: '' }
        this.loadCategories()
        this.loadProducts()
      } catch (e) { errorMessage('Falha ao salvar categoria.', 3000) }
    },
    async delCategory (c) {
      const ok = await this.$bvModal.msgBoxConfirm(`Remover "${c.name}"?`, { okTitle: 'Remover', cancelTitle: 'Cancelar', okVariant: 'danger' })
      if (!ok) return
      try { await services.deleteStoreCategory(c.id); this.loadCategories(); this.loadProducts() } catch (e) { errorMessage(e?.response?.data?.message || 'Falha ao remover.', 3000) }
    },
    // Pedidos
    openOrder (o) { this.orderForm = { ...o, delivery_type: o.delivery_type || null }; this.orderModal = true },
    async saveOrder () {
      this.saving = true
      try {
        await services.updateStoreOrder(this.orderForm.id, {
          status: this.orderForm.status,
          delivery_type: this.orderForm.delivery_type,
          tracking_code: this.orderForm.delivery_type === 'Retirou no local' ? null : this.orderForm.tracking_code
        })
        this.orderModal = false
        successMessage('Pedido atualizado.', 2000)
        this.loadOrders()
      } catch (e) { errorMessage('Falha ao atualizar pedido.', 3000) } finally { this.saving = false }
    },
    // Carteira
    openAdjust (b) {
      this.adjustForm = b
        ? { participant_id: b.participant_id, name: b.name, locked: true, type: 'credit', points: 0, description: '' }
        : { participant_id: null, type: 'credit', points: 0, description: '' }
      this.adjustModal = true
    },
    async doAdjust () {
      this.saving = true
      try {
        const r = await services.adjustWallet({
          participant_id: this.adjustForm.participant_id,
          type: this.adjustForm.type,
          points: this.adjustForm.points,
          description: this.adjustForm.description || null
        })
        this.adjustModal = false
        successMessage('Novo saldo: ' + r.data.balance + ' pts', 2500)
        this.loadBalances()
      } catch (e) { errorMessage(e?.response?.data?.message || 'Falha no ajuste.', 3000) } finally { this.saving = false }
    }
  }
}
</script>
